import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "time"
}
const _hoisted_2 = {
  key: 0,
  class: "audio"
}
const _hoisted_3 = {
  key: 1,
  class: "photo"
}
const _hoisted_4 = { class: "photo__action" }
const _hoisted_5 = {
  key: 2,
  class: "document"
}
const _hoisted_6 = { class: "document__action" }
const _hoisted_7 = {
  key: 3,
  class: "video"
}
const _hoisted_8 = {
  key: 4,
  class: "call"
}
const _hoisted_9 = {
  key: 5,
  class: "text"
}
const _hoisted_10 = {
  key: 2,
  class: "time"
}
const _hoisted_11 = { class: "history" }
const _hoisted_12 = { class: "history__item--date" }
const _hoisted_13 = {
  class: "history__item--message",
  lang: "en"
}
const _hoisted_14 = { class: "modal__footer" }

import {IChatMessage} from "@/features/personal/personal.types";
import {DateTime} from "luxon";
import VoiceMessage from "@/features/message/ui/voiceMessage.vue";
import {Image01, File06, DotsVertical} from "utruckin-icons";
import CallMessage from "@/features/message/ui/callMessage.vue";
import VideoMessage from "@/features/message/ui/videoMessage.vue";
import {IMessageHistory} from "@/types/main";
import {ref} from "vue";
import CommonModal from "@/components/common/CommonModal.vue";
import CommonButton from "@/components/common/CommonButton.vue";

interface IPersonalChat {
  item: IChatMessage
}


export default /*@__PURE__*/_defineComponent({
  __name: 'personalChat',
  props: {
    item: {}
  },
  setup(__props: any) {

const props = __props;

const historyModal = ref<boolean>(false);
const messageHistory = ref<IMessageHistory[]>([])

const apiBaseUrl = process.env.VUE_APP_API_BASE_URL;

const formatDate = (value: string): string => {
  return DateTime.fromFormat(value, 'yyyy-MM-dd HH:mm:ss', {
    zone: 'utc',
  })
      .setZone('America/New_York')
      .toFormat('HH:mm')
}

const imageClick = (item: any, event: MouseEvent) => {
  event.stopPropagation()
  window.open(`${apiBaseUrl}${item.media_path}`, "_blank");
}

const showHistory = () => {
  let newHistory: IMessageHistory[] = [...props.item.history];
  newHistory.push({
    id: props.item.message_id,
    edited_at: props.item.activity_time,
    old_text: props.item.text,
  })

  const lastEditedAt = newHistory[newHistory.length - 1].edited_at;
  for (let i = newHistory.length - 1; i > 0; i--) {
    newHistory[i].edited_at = newHistory[i - 1].edited_at;
  }

  newHistory[0].edited_at = lastEditedAt;

  console.log(newHistory);

  historyModal.value = true;
  messageHistory.value = newHistory;
}

const closeModal = () => {
  messageHistory.value = []
}

const closeHistoryModal = () => {
  historyModal.value = false;
  closeModal();
}

const formatHistoryDate = (value: string) => {
  let newValue;
  if (value.includes("T")) {
    newValue = DateTime.fromISO(value, {
      zone: 'utc',
    })
        .setZone('America/New_York')
        .toFormat('yyyy-MM-dd HH:mm:ss')
  } else {
    newValue = DateTime.fromFormat(value, 'yyyy-MM-dd HH:mm:ss', {
      zone: 'utc',
    })
        .setZone('America/New_York')
        .toFormat('yyyy-MM-dd HH:mm:ss')
  }

  let time: string;

  time = newValue.split(" ")[1];

  return time.split(":")[0] + ":" + time.split(":")[1] + ":" + time.split(":")[2];
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["w-ui-personal-chat", __props.item.is_outgoing ? '' : 'left'])
    }, [
      (!__props.item.is_outgoing)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(formatDate(__props.item.activity_time)), 1))
        : _createCommentVNode("", true),
      (__props.item.is_outgoing && __props.item.is_edited)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "additional",
            onClick: showHistory
          }, [
            _createVNode(_unref(DotsVertical), { size: 16 })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["message", __props.item.is_outgoing ? '' : 'left'])
      }, [
        (__props.item.msg_type == 'audio')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(VoiceMessage, {
                "audio-url": `${_unref(apiBaseUrl)}${__props.item.media_path}`
              }, null, 8, ["audio-url"])
            ]))
          : _createCommentVNode("", true),
        (__props.item.msg_type == 'photo')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", {
                  class: "picture",
                  onClick: _cache[0] || (_cache[0] = (e) => imageClick(__props.item, e))
                }, [
                  _createVNode(_unref(Image01), { size: 32 })
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (__props.item.msg_type == 'document')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", {
                  class: "document",
                  onClick: _cache[1] || (_cache[1] = (e) => imageClick(__props.item, e))
                }, [
                  _createVNode(_unref(File06), { size: 32 })
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (__props.item.msg_type == 'video')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(VideoMessage, {
                "document-url": `${_unref(apiBaseUrl)}${__props.item.media_path}`
              }, null, 8, ["document-url"])
            ]))
          : _createCommentVNode("", true),
        (__props.item.item_type == 'call')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(CallMessage, { item: __props.item }, null, 8, ["item"])
            ]))
          : _createCommentVNode("", true),
        (__props.item.text)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(__props.item.text), 1))
          : _createCommentVNode("", true)
      ], 2),
      (__props.item.is_outgoing)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(formatDate(__props.item.activity_time)), 1))
        : _createCommentVNode("", true),
      (!__props.item.is_outgoing && __props.item.is_edited)
        ? (_openBlock(), _createElementBlock("div", {
            key: 3,
            class: "additional",
            onClick: showHistory
          }, [
            _createVNode(_unref(DotsVertical), { size: 16 })
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(CommonModal, {
      modelValue: historyModal.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((historyModal).value = $event)),
      onClose: closeModal
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(CommonButton, {
            type: "primary",
            label: "Close",
            onClicked: closeHistoryModal
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messageHistory.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "history__item",
              key: index
            }, [
              _createElementVNode("div", _hoisted_12, _toDisplayString(formatHistoryDate(item.edited_at)), 1),
              _createElementVNode("div", _hoisted_13, _toDisplayString(item.old_text), 1)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})